import DatePickerComponent from './DatePicker';
export default DatePickerComponent;
